import ConnectionsPlanning from "../../components/Games/connections_planning";
import CombinationsPlanning from "../../components/Games/combinations_planning";
import HorseJumpPlanning from "../../components/Games/horsejump_planning";
import SudotetrisPlanning from "../../components/Games/sudotetris_planning";
import SpellingBeePlanner from "../../components/Games/spellingbee_planner";
import CrosswordPlanner from "../../components/Games/crossword_planner";
import WordlePlanning from "../../components/Games/wordle_planning";
import WordSearchPlanning from "../../components/Games/wordsearch_planning";

// Map of component names to their actual components
const componentMapping = {
  "ConnectionsPlanning": ConnectionsPlanning,
  "CombinationsPlanning": CombinationsPlanning,
  "HorseJumpPlanning": HorseJumpPlanning,
  "SudotetrisPlanning": SudotetrisPlanning,
  "SpellingBeePlanner": SpellingBeePlanner,
  "CrosswordPlanner": CrosswordPlanner,
  "WordlePlanning": WordlePlanning,
  "WordSearchPlanning": WordSearchPlanning,
  // Add more components here as needed
  // "SomeOtherComponent": SomeOtherComponent,
};

// Map of game IDs to additional components to render on their pages
// Extend this as needed for other games/components
const componentPageMap = {
  23: ["ConnectionsPlanning"], // Game ID 23: render 'ConnectionsPlanning' component
  35: ["ConnectionsPlanning"], // Game ID 35: render 'ConnectionsPlanning' component
  37: ["ConnectionsPlanning"], // Game ID 37: render 'ConnectionsPlanning' component
  2: ["CombinationsPlanning"], // Game ID 2: render 'CombinationsPlanning' component
  10: ["CombinationsPlanning"], // Game ID 10: render 'CombinationsPlanning' component
  33: ["HorseJumpPlanning"], // Game ID 33: render 'HorseJumpPlanning' component
  4: ["SudotetrisPlanning"], // Game ID 34: render 'SudotetrisPlanning' component
  16: ["SudotetrisPlanning"], // Game ID 16: render 'SudotetrisPlanning' component
  21: ["SpellingBeePlanner"], // Example Game ID for Spelling Bee
  39: ["SpellingBeePlanner"], // Game ID 39: render 'SpellingBeePlanner' component
  17: ["CrosswordPlanner"], // Game ID 17: render 'CrosswordPlanner' component
  24: ["WordlePlanning"], // Game ID 24: render 'WorldePlanning' component
  29: ["WordlePlanning"], // Game ID 29: render 'WordlePlanning' component
  30: ["WordlePlanning"], // Game ID 30: render 'WordlePlanning' component
  31: ["WordlePlanning"], // Game ID 31: render 'WordlePlanning' component
  38: ["WordlePlanning"], // Game ID 38: render 'WordlePlanning' component
  22: ["WordSearchPlanning"], // Game ID 22: render 'WordSearchPlanning' component
};

export { componentMapping, componentPageMap };
export default componentPageMap; 